<div class="dialog">
  <div mat-dialog-title class="popup-header">
    <div class="popup-title">Booking Details </div>
    <button class="popup-btn-close" [mat-dialog-close]="true">X</button>
  </div>
  <div class="hr"></div>
  <div class="details-area">
    <div class="appointment-date-container">
      <div class="appointment-date">
        <div class="day-of-week">{{data.appointmentDate | date: "EEEE"}}</div>
        <div class="month">{{data.appointmentDate | date: "MMMM dd"}}</div>
        <div class="year">{{data.appointmentDate | date: "yyyy"}}</div>
      </div>
    </div>
    <div class="time-slot">{{data.startTime | time}} &nbsp; - &nbsp;{{data.endTime | time}}</div>
    <div class="record-row">
      <div class="label">Patient First Name :</div>
      <div class="data">{{data.lead.firstName}}</div>
    </div>
    <div class="record-row">
      <div class="label">Patient Last Name :</div>
      <div class="data">{{data.lead.lastName}}</div>
    </div>
    @if (!isDefaultDate(data.lead.birthDate)) {
      <div class="record-row">
        <div class="label">Patient Brithdate:</div>
        <div class="data">{{data.lead.birthDate | date: "MMMM dd, yyyy"}}</div>
      </div>
    }
    <div class="record-row">
      <div class="label">Responsible Party :</div>
      @if (data.lead.responsiblePartyFirstName || data.lead.responsiblePartyLastName) {
        <div class="data">
        {{data.lead.responsiblePartyFirstName}} {{data.lead.responsiblePartyLastName}}</div>
      }
      @if (!data.lead.responsiblePartyFirstName && !data.lead.responsiblePartyLastName) {
        <div class="data">n/a</div>
      }
    </div>
    <div class="record-row">
      <div class="label">Email :</div>
      <div class="data">{{data.lead.email}}</div>
    </div>
    <div class="record-row">
      <div class="label">Mobile :</div>
      <div class="data">{{data.lead.cellPhone | phoneNumber}}</div>
    </div>
    <div class="record-row">
      <div class="label">Insurance :</div>
      @if (data.hasInsurance) {
        <div class="data">Yes</div>
      }
      @if (!data.hasInsurance) {
        <div class="data">No</div>
      }
    </div>
    <div class="record-row">
      <div class="label">I'd like to have another person seen at the same time (I have more than one child) :</div>
      @if (data.isGroupVisit) {
        <div class="data">Yes</div>
      }
      @if (!data.isGroupVisit) {
        <div class="data">No</div>
      }
    </div>
    <div class="record-row">
      <div class="label">Booking Date :</div>
      <div class="data">{{data.bookingDate | date: "MMMM dd, yyyy"}}</div>
    </div>
    @if (data.leadSource) {
      <div class="record-row">
        <div class="label">How did you hear about us?</div>
        <div class="data">{{data.leadSource.leadSourceName}}</div>
      </div>
    }
    @if (data.leadSource) {
      <div class="record-row">
        <div class="label">Details :</div>
        <div class="data">{{data.leadSourceDetails}}</div>
      </div>
    }
  </div>
</div>
